import { useContext, useEffect, useState } from 'react'
import Button from '../common/Button'
import { putRequest } from '../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../context/global_context'
import { Card, Flex, Form } from 'antd'
import SelectInput from '../common/SelectInput'
import { useVehicles } from '../../context/vehicle_context'

const CSV_OPTIONS = [
  { value: 'wire_list', label: 'Wire list' },
  { value: 'dtcs', label: 'Dtcs' },
  { value: 'dtcs_dependencies', label: 'Dtcs Dependencies' },
  { value: 'modules', label: 'Modules' },
  { value: 'inlines', label: 'Inlines' },
  { value: 'harness_description', label: 'Harness description' },
  { value: 'sig_list', label: 'Sig list' },
  { value: 'sales_codes', label: 'Sales codes' },
  { value: 'sales_code_constraints', label: 'Sales code constraints' },
  { value: 'connector_layout', label: 'Connector layout' },
  { value: 'device_connections', label: 'Device connections' },
  { value: 'power_distributions', label: 'Power distributions' },
  { value: 'component_list', label: 'Component list' },
  { value: 'functional_diagram', label: 'Functional Diagram' },
]

const CsvDependencies = (props) => {
  const { vehicleDetails } = props
  const { make_model_id, metadata } = vehicleDetails

  const { vehicle } = useParams()
  const [selectedValue, setSelectedValue] = useState({})
  const [state, dispatch] = useContext(NavContext)
  const [form] = Form.useForm()
  const { selectedVehicleName } = useVehicles()

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: vehicle
          ? `Vehicle List / ${selectedVehicleName} / CSV Dependencies`
          : '',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: vehicle,
        full_width_container: false,
      },
    })
  }, [])

  useEffect(() => {
    if (make_model_id && metadata) {
      setSelectedValue(metadata)
      form.setFieldsValue(metadata)
    }
  }, [props.vehicleDetails])

  const saveCsvDependency = async (values) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Saving CSV Dependency',
        showLoader: true,
      },
      notification: {},
    })

    let res = await putRequest(
      `/api/vehicles/save_csv_dependency/${vehicle}/`,
      values
    )

    dispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: 'CSV Dependency saved successfully',
      },
    })
  }

  return (
    <>
      <div className="vehicle-form csv-dependencies-wrapper">
        <Form
          id="vehicle-form-csv-dependencies"
          name="vehicle-form-csv-dependencies"
          form={form}
          layout="vertical"
          onFinish={saveCsvDependency}
        >
          <Card title="" variant="outlined">
            <Flex
              style={{ paddingTop: 16, paddingBottom: 16 }}
              vertical
              gap={16}
            >
              {CSV_OPTIONS.map((dependency) => {
                return (
                  <SelectInput
                    key={dependency.value}
                    name={dependency.value}
                    isRequired={false}
                    label={dependency.label}
                    isMulti={true}
                    options={CSV_OPTIONS}
                    placeholder="Select Dependency"
                    onChange={(value) => {
                      setSelectedValue({
                        ...selectedValue,
                        [dependency.value]: value,
                      })
                    }}
                  />
                )
              })}
            </Flex>
          </Card>
          <Button htmlType="submit" type="primary">
            Save CSV dependencies
          </Button>
        </Form>
      </div>
    </>
  )
}

export default CsvDependencies
